import { getRoutes } from '@ui-framework/index';
import UserEdit from './pages/edit/index';
import UserCreate from './pages/create/index';
import UserList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import UserFormStore from './store/index';
import UserListStore from './store/list';

const Pages = ProtectedRoute => ({
  UserEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UserEdit}
    />
  ),
  UserCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UserCreate}
    />
  ),
  UserList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={UserList}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    userFormStore: new UserFormStore(rootStore),
    userListStore: new UserListStore(rootStore),
  },
];

export { UserEdit, UserCreate, UserList, routes, stores };
